/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentProviderLocation/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import PaymentProviderLocationSelector from './PaymentProviderLocationSelector/index'
import PlatformFeeWarning from './PlatformFeeWarning/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentProviderLocation({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderLocation"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="PaymentProviderLocation.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-2hePn5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<PaymentProviderLocationSelector
  viewPath={`${viewPath}/PaymentProviderLocationSelector`}
/>
<PlatformFeeWarning
  viewPath={`${viewPath}/PlatformFeeWarning`}
/>
</div>
{children}
</React.Fragment>)
}